import React from 'react'
import styles from './EmbedBlock.scss'
import shallowCompare from 'react-addons-shallow-compare'
import {Block} from '../Block'
import {BlockCaption} from '../BlockCaption'

export class EmbedBlock extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showPopover: false
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  onSourceChange = (e) => {
    const val = e.target.value

    if (val.match('iframe')) {
      const el = document.createElement('div')
      el.innerHTML = val

      const ifr = el.firstElementChild

      const props = {
        src: ifr.src,
        width: ifr.width || ifr.style.width,
        height: ifr.height || ifr.style.height
      }

      if (props['width'] && props['height']) {
        props['height'] = props['height'].match('\\d+')[ 0 ]
        if (!props['width'].match('%')) {
          // width isn't a percentage
          // generate a ratio

          const width = props['width'].match('\\d+')[ 0 ]
          props['ratio'] = (props['height'] / width)
        }
      }

      this.props.blockProps.onChange(props)
    }

    // TODO parse normal youtube etc links
  }

  render () {
    const {block, blockProps} = this.props
    const data = block.getData()
    const src = data.get('src')

    if (!src) {
      return (
        <Block block={block} blockProps={blockProps}>
          <form>
            <h2>Put in your embed for magic to happen</h2>
            <p>Source: <textarea onChange={this.onSourceChange} /></p>
          </form>
        </Block>
      )
    } else {
      const ratio = data.get('ratio')
      const height = data.get('height', 480)

      const dstyle = {}

      if (ratio) {
        dstyle['paddingTop'] = `${100 * ratio}%`
      } else {
        dstyle['paddingTop'] = `${height}px`
      }

      return (
        <Block block={block} blockProps={blockProps}>
          <div className={styles.EmbedBlock} style={dstyle}>
            <iframe src={`${src}`} frameBorder='0' />
          </div>
          <BlockCaption block={this.props.block} blockProps={this.props.blockProps} />
        </Block>
      )
    }
  }
}
